// доработать типы аргументов
export const conditionsSx = (
  condition: any,
  ifValue: any,
  elseValue: any = null
): any => {
  return !!condition ? ifValue : elseValue;
};
